// extracted by mini-css-extract-plugin
module.exports = {"md":"feedback-sheet_md_MPr7a","ios":"feedback-sheet_ios_3F6ZT","sheet":"feedback-sheet_sheet_2msEq","handler":"feedback-sheet_handler_2gJ3n","close":"feedback-sheet_close_260zM"};